export const getInitialState = () => {
  return {
    masses: {
      anytimeFetched: false,
      loading: false,
      error: false,
    },
  };
};
